import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { isMsWindow } from '@aws-crypto/ie11-detection';
import { supportsWebCrypto, supportsSubtleCrypto, supportsZeroByteGCM } from '@aws-crypto/supports-web-crypto';
import { synchronousRandomValues as randomValues } from './synchronous_random_values';
import promisifyMsSubtleCrypto from './promisify-ms-crypto';
export function webCryptoBackendFactory(window) {
  var fallbackRequiredPromise = windowRequiresFallback(window);
  var webCryptoFallbackPromise = false;
  return {
    getWebCryptoBackend: getWebCryptoBackend,
    configureFallback: configureFallback
  };

  function getWebCryptoBackend() {
    return _getWebCryptoBackend.apply(this, arguments);
  }

  function _getWebCryptoBackend() {
    _getWebCryptoBackend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fallbackRequired, subtle, webCryptoFallback;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              randomValues(1);
              _context.next = 7;
              break;

            case 4:
              _context.prev = 4;
              _context.t0 = _context["catch"](0);
              throw new Error('No supported secure random');

            case 7:
              _context.next = 9;
              return fallbackRequiredPromise;

            case 9:
              fallbackRequired = _context.sent;
              subtle = pluckSubtleCrypto(window);
              _context.next = 13;
              return webCryptoFallbackPromise;

            case 13:
              webCryptoFallback = _context.sent;

              if (!(subtle && fallbackRequired && !webCryptoFallback)) {
                _context.next = 16;
                break;
              }

              throw new Error('A Fallback is required for zero byte AES-GCM operations.');

            case 16:
              if (!(!subtle && !webCryptoFallback)) {
                _context.next = 18;
                break;
              }

              throw new Error('A Fallback is required because no subtle backend exists.');

            case 18:
              if (!(!fallbackRequired && subtle)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", {
                subtle: subtle,
                randomValues: randomValues
              });

            case 20:
              if (!(fallbackRequired && subtle && webCryptoFallback)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", {
                nonZeroByteSubtle: subtle,
                randomValues: randomValues,
                zeroByteSubtle: webCryptoFallback
              });

            case 22:
              if (!(fallbackRequired && !subtle && webCryptoFallback)) {
                _context.next = 24;
                break;
              }

              return _context.abrupt("return", {
                subtle: webCryptoFallback,
                randomValues: randomValues
              });

            case 24:
              throw new Error('unknown error');

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 4]]);
    }));
    return _getWebCryptoBackend.apply(this, arguments);
  }

  function configureFallback(_x) {
    return _configureFallback.apply(this, arguments);
  }

  function _configureFallback() {
    _configureFallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fallback) {
      var fallbackRequired;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fallbackRequiredPromise;

            case 2:
              fallbackRequired = _context2.sent;

              if (fallbackRequired) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              if (!webCryptoFallbackPromise) {
                _context2.next = 7;
                break;
              }

              throw new Error('Fallback reconfiguration denied');

            case 7:
              if (supportsSubtleCrypto(fallback)) {
                _context2.next = 9;
                break;
              }

              throw new Error('Fallback does not support WebCrypto');

            case 9:
              // This if to lock the fallback.
              // when using the fallback, it is simpler
              // for the customer to not await the success
              // of configuration so we handle it for them
              // I still return in case they want to await
              webCryptoFallbackPromise = supportsZeroByteGCM(fallback).then(function (zeroByteGCMSupport) {
                /* Postcondition: The fallback must specifically support ZeroByteGCM. */
                if (!zeroByteGCMSupport) throw new Error('Fallback does not support zero byte AES-GCM');
                return fallback;
              });
              return _context2.abrupt("return", webCryptoFallbackPromise);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _configureFallback.apply(this, arguments);
  }
}
export function getNonZeroByteBackend(backend) {
  /* Precondition: A backend must be passed to get a non zero byte backend. */
  if (!backend) throw new Error('No supported backend.');
  return backend.subtle || backend.nonZeroByteSubtle;
}
export function getZeroByteSubtle(backend) {
  /* Precondition: A backend must be passed to get a zero byte backend. */
  if (!backend) throw new Error('No supported backend.');
  return backend.subtle || backend.zeroByteSubtle;
}
export function windowRequiresFallback(_x2) {
  return _windowRequiresFallback.apply(this, arguments);
}

function _windowRequiresFallback() {
  _windowRequiresFallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(window) {
    var subtle, zeroByteSupport;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            subtle = pluckSubtleCrypto(window);

            if (subtle) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", true);

          case 3:
            _context3.next = 5;
            return supportsZeroByteGCM(subtle);

          case 5:
            zeroByteSupport = _context3.sent;
            return _context3.abrupt("return", !zeroByteSupport);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _windowRequiresFallback.apply(this, arguments);
}

export function pluckSubtleCrypto(window) {
  // if needed webkitSubtle check should be added here
  // see: https://webkit.org/blog/7790/update-on-web-cryptography/
  if (supportsWebCrypto(window)) return window.crypto.subtle;
  if (isMsWindow(window)) return promisifyMsSubtleCrypto(window.msCrypto.subtle);
  return false;
}
export function isFullSupportWebCryptoBackend(backend) {
  return !!backend.subtle;
}